import { render, staticRenderFns } from "./faut-il-privilegier-un-site-wordpress-ou-une-solution-sur-mesure.vue?vue&type=template&id=82573a56&"
import script from "./faut-il-privilegier-un-site-wordpress-ou-une-solution-sur-mesure.vue?vue&type=script&lang=js&"
export * from "./faut-il-privilegier-un-site-wordpress-ou-une-solution-sur-mesure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports